import { useBaseApiQuery } from "@query/baseQuery";
import { keepPreviousData } from "@tanstack/react-query";

export const useAccountQuery = () => {
    return useBaseApiQuery({ endpoint: "/organization/me" }, { queryKey: ["me"] }) ;
};

export const useAdminAccountListQuery = (page, pageSize) => {
    return useBaseApiQuery(
        { endpoint: `organization/me/account/page/${page}?pageSize=${pageSize}`},
        { queryKey: ["admin_accounts_list_page",  page, pageSize]}
    );
};


export const useAdminAccountUUIDQuery = (account_uuid) => {
    return useBaseApiQuery(
        { endpoint:  `/organization/me/account/${account_uuid}`},
        { queryKey: ["useAdminAccountUUIDQuery",  account_uuid]}
    );
};

export const useAccountSearchAllQuery = ({ page, search, pageSize }) => {
  return useBaseApiQuery(
    {
      endpoint: `/account/me/account/search/admin/all/page/${page}`,
      params: { name: search || null, page_size: pageSize || null },
    },
    {
      queryKey: ["account_search_all", page, pageSize, search],
      placeholderData: keepPreviousData,
    }
  );
};
